import Cropper from 'cropperjs'

export const CROP_DIMENSION = 132

export const cropperSetup = (file, refs) => {
  const { canvasRef, cropperRef, drawBoxRef, maskRef, rotateRef, zoomRef } = refs
  const canvas = canvasRef.current
  const drawBox = drawBoxRef.current
  const mask = maskRef.current
  const zoomSlide = zoomRef.current
  const rotateSlide = rotateRef.current

  const fileReader = new FileReader()
  fileReader.onload = () => {
    const img = new Image()
    img.onload = () => {
      const maskHeight = 560
      const maskWidth = 960
      mask.height = maskHeight
      mask.width = maskWidth
      const ctxMask = mask.getContext('2d')
      ctxMask.fillStyle = '#f5f5f5'
      ctxMask.fillRect(0, 0, maskWidth, maskHeight)
      ctxMask.globalCompositeOperation = 'destination-out'
      ctxMask.fillStyle = '#f5f5f5'
      ctxMask.arc(maskWidth / 2, maskHeight / 2, 80, 0, Math.PI * 2)
      ctxMask.fill()

      const MAX_WIDTH = 1000
      const MAX_HEIGHT = 1000
      let { width } = img
      let { height } = img

      // Add the resizing logic
      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width
          width = MAX_WIDTH
        }
      } else if (height > MAX_HEIGHT) {
        width *= MAX_HEIGHT / height
        height = MAX_HEIGHT
      }

      canvas.width = width
      canvas.height = height
      drawBox.width = `${width}px`
      drawBox.height = `${height}px`

      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, width, height)
      canvas.toDataURL()
      cropperRef.current = new Cropper(canvas, {
        viewMode: 0,
        dragMode: 'move',
        guides: false,
        center: true,
        movable: true,
        cropBoxMovable: false,
        cropBoxResizable: false,
        minCropBoxHeight: CROP_DIMENSION,
        minCropBoxWidth: CROP_DIMENSION,
        zoomOnWheel: false,
        crop() {
          const viewBoxContainer = document.getElementsByClassName('cropper-view-box')[0]

          if (!viewBoxContainer) {
            return
          }

          const computedStyle = window.getComputedStyle(viewBoxContainer.parentElement as HTMLElement)
          const matrix = computedStyle.transform
          const matrixMatch = matrix.match(/matrix.*\((.+)\)/)
          const matrixValues = matrixMatch?.[1].split(', ')
          if (!matrixValues) {
            return
          }
          const left = matrixValues[4]
          const right = matrixValues[5]

          const viewBox = viewBoxContainer.firstChild as HTMLElement
          const refHeight = parseFloat(viewBox?.style.height)
          const refWidth = parseFloat(viewBox?.style.width)

          drawBox.style.left = `${left}px`
          drawBox.style.top = `${right}px`
          drawBox.style.height = `${refHeight + 1}px`
          drawBox.style.width = `${refWidth + 1}px`
          drawBox.style.transform = viewBox.style.transform
        },

        ready() {
          const data = cropperRef.current.getContainerData()
          cropperRef.current.zoomTo(0.5)
          const zoomedValues = cropperRef.current.getImageData()
          cropperRef.current.moveTo(data.width / 2 - zoomedValues.width / 2, data.height / 2 - zoomedValues.height / 2)
          zoomSlide.value = 0.5
          rotateSlide.value = 0
        },
      })
    }

    img.src = fileReader.result as string
  }
  fileReader.readAsDataURL(file)

  zoomSlide.addEventListener('input', (event) => {
    const { value } = event.target
    cropperRef.current.zoomTo(parseFloat(value).toFixed(4))
  })

  rotateSlide.addEventListener('input', (event) => {
    const degree = event.target.value * 3.6
    cropperRef.current.rotateTo(degree)
  })
}
